// /client/src/components/ProjectForm.js

import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
  Stack
} from '@mui/material';

const ProjectForm = ({ open, onClose, onSave, project }) => {
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    tags: '',
    imageUrl: '',
    liveUrl: '',
    githubUrl: '',
  });

  useEffect(() => {
    // If a project is passed, we're in "edit" mode
    if (project) {
      setFormData({
        title: project.title,
        description: project.description,
        tags: project.tags.join(', '), // Convert array to comma-separated string for the form
        imageUrl: project.imageUrl,
        liveUrl: project.liveUrl || '',
        githubUrl: project.githubUrl || '',
      });
    } else {
      // Otherwise, we're in "add" mode, so reset the form
      setFormData({
        title: '', description: '', tags: '', imageUrl: '', liveUrl: '', githubUrl: '',
      });
    }
  }, [project, open]); // Rerun effect if the project or open state changes

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSave = () => {
    const finalData = {
      ...formData,
      tags: formData.tags.split(',').map(tag => tag.trim()), // Convert string back to array
    };
    onSave(finalData, project ? project._id : null);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{project ? 'Edit Project' : 'Add New Project'}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 2 }}>
          <TextField name="title" label="Title" value={formData.title} onChange={handleChange} fullWidth required />
          <TextField name="description" label="Description" value={formData.description} onChange={handleChange} multiline rows={4} fullWidth required />
          <TextField name="tags" label="Tags (comma-separated)" value={formData.tags} onChange={handleChange} fullWidth required />
          <TextField name="imageUrl" label="Image URL" value={formData.imageUrl} onChange={handleChange} fullWidth required />
          <TextField name="liveUrl" label="Live Demo URL" value={formData.liveUrl} onChange={handleChange} fullWidth />
          <TextField name="githubUrl" label="GitHub URL" value={formData.githubUrl} onChange={handleChange} fullWidth />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSave} variant="contained">Save</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProjectForm;